<script>
import mbxGeocoding from "@mapbox/mapbox-sdk/services/geocoding";
import config from "../config";

const geocodingClient = mbxGeocoding({
  accessToken: config.mapboxAccessToken,
});

export default {
  name: "LocationChooser",
  data() {
    return {
      search: "",
      results: [],
    };
  },
  methods: {
    refresh() {
      this.loading = true;
      this.error = "";

      if (this.search.length > 0) {
        geocodingClient
          .forwardGeocode({
            query: this.search,
            types: ["place"],
            autocomplete: false,
            limit: 5,
          })
          .send()
          .then((response) => {
            this.results = response.body.features;
            console.log(this.results);
          })
          .catch((e) => (this.error = e.message));
      } else {
        this.results = [];
      }
    },
    select(index) {
      if (this.results.length > 0 && this.results[index]) {
        this.$store.commit("addLoc", this.results[index]);
        this.search = "";
        this.results = [];
      }
    },
  },
  computed: {
    showResults() {
      return this.search.length > 0;
    },
  },
};
</script>
<template>
  <div class="location-chooser">
    <input
      type="text"
      placeholder="Search place"
      v-model="search"
      @input="refresh"
      @keypress.enter="select(0)"
    />
    <div v-if="showResults" class="results">
      <div
        v-for="(result, index) in results"
        :key="result.id"
        class="place"
        @click="select(index)"
      >
        {{ result.place_name }}
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.location-chooser {
  margin: 0 20px;
  position: relative;

  .results {
    position: absolute;
    background-color: var(--card-color);
    box-shadow: var(--dark-shadow);
    margin: 10px 0;
    width: 100%;
    z-index: 1;
    border-radius: 5px;
    overflow: hidden;

    .place {
      padding: 0.8rem;
      white-space: nowrap;
      overflow: hidden;

      &:hover {
        background-color: var(--light-color);
      }
    }
  }

  input[type="text"] {
    appearance: none;
    background-color: var(--card-color);

    width: 100%;
    border: solid 2px var(--text-color);
    border-radius: 5px;
    color: var(--text-color);
    padding: 10px;
    font-size: 18px;
    line-height: 100%;
    outline: none;
    box-shadow: var(--light-shadow);
    caption-side: top;
    transition: box-shadow 0.2s;
    user-select: auto;

    &::placeholder {
      line-height: normal;
      color: var(--light-color);
    }

    &:focus {
      box-shadow: var(--dark-shadow);
    }
  }
}
</style>